import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'bytes',
	standalone: true,
})
export class BytesPipe implements PipeTransform {
	transform(value: number | string, ..._args: unknown[]): string {
		const valueAsNumber: number = typeof value === 'string' ? Number.parseInt(value, 10) : value
		let bytes = `${valueAsNumber} B`

		if (valueAsNumber > 100) {
			const kB = valueAsNumber / 1000
			bytes = `${kB.toFixed()} kB`
		}

		if (valueAsNumber > 1_000_000) {
			const kB = valueAsNumber / 1000
			const MB = kB / 1000
			bytes = `${MB.toFixed(2)} MB`
		}

		return bytes
	}
}
